import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography, CircularProgress } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import task from "../assets/StatusIcons/task.svg";
import leave from "../assets/StatusIcons/leave.svg";
const TaskStatusDropdown = ({ currentStatus, onChange, loading }) => {
  const { t } = useTranslation();

  const priorityOptions = ["low", "medium", "high", "urgent"];

  const statusIcons = {
    low: task,
    medium: task,
    high: task,
    urgent: task,
    assigned: leave,
  };

  const statusStyles = {
    low: { backgroundColor: '#BCBFC2', color: '#44546F' },
    medium: { backgroundColor: '#579DFF', color: '#09326C' },
    high: { backgroundColor: '#FEA362', color: '#702E00' },
    urgent: { backgroundColor: '#F87168', color: '#5D1F1A' },
     assigned: { backgroundColor: '#579DFF', color: '#09326C' },
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (priority) => {
    if (priority && !loading) onChange(priority);
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 0.6,
          py: 0.4,
          borderRadius: '4px',
          fontWeight: 400,
          fontFamily: 'Poppins, sans-serif',
          fontSize: '13px',
          cursor: "pointer",
          whiteSpace: 'nowrap',
          ...statusStyles[currentStatus]
        }}
      >
        <img
          src={statusIcons[currentStatus]}
          alt={currentStatus}
          style={{ width: 20, height: 20 }}
        />

        <Typography
          sx={{
            fontSize: '13px',
            fontFamily: 'Poppins, sans-serif',
            color: statusStyles[currentStatus]?.color || '#333'
          }}
        >
          {t(`statuses.${currentStatus}`)}
        </Typography>

        {/* ✅ Show loader while API calling */}
        {loading ? (
          <CircularProgress size={14} sx={{ color: statusStyles[currentStatus]?.color || '#333' }} />
        ) : (
          <ArrowDropDownIcon
            sx={{ fontSize: 18, color: statusStyles[currentStatus]?.color || '#333' }}
          />
        )}
      </Box>

      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
        {priorityOptions.map((priority) => (
          <MenuItem key={priority} onClick={() => handleClose(priority)}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <img
                src={statusIcons[priority]}
                alt={priority}
                style={{ width: 16, height: 16 }}
              />
              <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px' }}>
                {t(`statuses.${priority}`)}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TaskStatusDropdown;
